import {TranslateService} from '@ngx-translate/core';

import {LocalizationService} from '../../../../../shared/localization/localization.service';
import {Chart} from '../../key-metrics.interfaces';
import {KeyMetricsTable} from '../../key-metrics.table';
import {ChartAbstract} from '../chart';

export abstract class Line extends ChartAbstract {

  public categories: string[];

  protected constructor(chart: Chart,
                        translate: TranslateService,
                        localization: LocalizationService) {
    super(chart, translate, localization);
    this.setBasicChart();
    this.categories = this.sortCategories(this.getCategories());

    this.xAxis = [{
      type: 'category',
      boundaryGap: false,
      data: this.categories
    }];

    const columns: string[] = this.categories.map((column: string) => this.translate.instant(column));
    this.table = new KeyMetricsTable([], columns, this.categories, []);
  }

  public pushTableRow(key: string, elementArray: number[]): void {
    this.table.addRowHeader(this.translate.instant(key));
    this.table.addData(elementArray
      .map((dataElement: number) => this.localization.localizeNumber(dataElement, 'DECIMAL_2_DIGIT'))
    );
  }

  public createLoadView(withTitle: boolean, withLabel: boolean): void {
    super.createLoadView(withTitle, withLabel);

    if (withLabel) {
      this.series.forEach((value: any) => {
        value.itemStyle = {
          normal: {
            label: {
              show: true,
              formatter: (value) => this.localization.localizeNumber(Math.abs(value.value), 'DECIMAL_2_DIGIT')
            }
          }
        };
      });
    }
    this.createChart();
  }

  public resetChart(): void {
    this.series.forEach((value: any) => {
      value.itemStyle = {
        normal: {
          label: {
            show: false
          }
        }
      };
    });
    super.resetChart();
  }
}
